import { Component, OnDestroy, OnInit } from '@angular/core';
import { GmbService } from '@boxx/gmb-core/lib/services/gmb.service';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
//import { GBP_CATEGORIES } from 'src/assets/gbp_categories';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-categories-picker',
  templateUrl: './categories-picker.component.html',
  styleUrls: ['./categories-picker.component.scss'],
})
export class CategoriesPickerComponent implements OnInit, OnDestroy {
  // types = GBP_CATEGORIES;
  // allTypes = GBP_CATEGORIES;
  searchBar: IonSearchbar;
  destroyed$ = new Subject<boolean>();
  categorySearch = '';
  isSearching = false;
  categoriesList: any;
  constructor(
    private modalCtrl: ModalController,
    public service: GmbService
  ) {
  }

  ngOnInit() {
    //this.allTypes = this.types;
  }

  ngOnDestroy() {
  }

  selectCategory(cat){
    const catSelected = cat;
    this.modalCtrl.dismiss({data: catSelected} );
  }

  search() {
    if (!this.categorySearch) {
      return;
    }
    this.isSearching = true;
    this.categoriesList = [];
    this.service.getGMBCategories(this.categorySearch).subscribe(
      (data) => {
        this.categoriesList = data;
        this.isSearching = false;
      }
    );
  }

  async close() {
    this.modalCtrl.dismiss();
  }

}
